module.exports = __webpack_public_path__ + "img/wechat.62cbb239.svg";